var InternalEmitterRequestType;
(function(InternalEmitterRequestType2) {
  InternalEmitterRequestType2["Connect"] = "connect";
})(InternalEmitterRequestType || (InternalEmitterRequestType = {}));
var InternalReceiverRequestType;
(function(InternalReceiverRequestType2) {
  InternalReceiverRequestType2["Ready"] = "ready";
})(InternalReceiverRequestType || (InternalReceiverRequestType = {}));
export {
  InternalEmitterRequestType,
  InternalReceiverRequestType
};
//# sourceMappingURL=types.js.map
